import {
    CSSEditor,
    CSSEditorComponentLabel,
    CSSEditorComponentWrapper,
    CSSEditorWidgetProperties,
} from 'components/Editors/components/Editor.style';

import { JRCButton } from 'components/JRCButton/JRCButton';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';

import {
    WidgetArticleAttachmentContent,
    WidgetStateProps,
    resolveFileMimetype,
    resolveFilePath,
} from 'jamespot-user-api';
import React from 'react';
import { useIntl } from 'react-intl';
import { arraySwapElements } from 'utils/utils.array';

import { WidgetMissingToken } from '../components/WidgetMissingToken';
import { CSSWidgetEditorListItem, CSSWidgetEditorListItemLabel, CSSWidgetEditorListOption } from '../styles';

import { BETA_JRCDragAndDrop } from 'components/Beta/BETA_JRCDragAndDrop/BETA_JRCDragAndDrop';

import { JRCFileAvatar } from 'components/JRCFile/JRCFileAvatar';

type JRCWidgetArticleAttachmentEditorProps = {
    token: string | undefined;
    content: WidgetArticleAttachmentContent;
    onChange: (content: Partial<WidgetArticleAttachmentContent>, override?: boolean) => void;
    onSave: (content: Partial<WidgetArticleAttachmentContent>) => void;
    onStateChange?: (state: WidgetStateProps) => void;
    onOpen?: (view: React.ReactElement) => void;
};

export const JRCWidgetArticleAttachmentEditor = ({
    token,
    content,
    onChange,
    onSave,
}: JRCWidgetArticleAttachmentEditorProps) => {
    const intl = useIntl();

    const onClickRemove = (index: number) => {
        if (content.files !== undefined) {
            onChange({ ...content, files: [...content.files.filter((_, n: number) => n !== index)] }, true);
        }
    };

    return (
        <CSSEditor>
            <CSSEditorWidgetProperties>
                {!token && <WidgetMissingToken />}
                {content.files !== undefined && (
                    <CSSEditorComponentWrapper>
                        <CSSEditorComponentLabel>
                            {intl.formatMessage({ id: 'PANEL_Files_List' })}
                        </CSSEditorComponentLabel>
                        <BETA_JRCDragAndDrop
                            elms={content.files ?? []}
                            renderEl={(file, index) => {
                                return file !== undefined ? (
                                    <CSSWidgetEditorListItem key={index}>
                                        <JRCFileAvatar
                                            uri={resolveFilePath(file)}
                                            size={40}
                                            mimetype={resolveFileMimetype(file)}
                                        />
                                        <div style={{ display: 'flex', flex: 1 }}>
                                            <CSSWidgetEditorListItemLabel>{file.title}</CSSWidgetEditorListItemLabel>
                                        </div>
                                        <CSSWidgetEditorListOption>
                                            <JRCIcon name="icon-fs-dw" />
                                        </CSSWidgetEditorListOption>
                                        <CSSWidgetEditorListOption onClick={() => onClickRemove(index)}>
                                            <JRCIcon name="icon-trash" />
                                        </CSSWidgetEditorListOption>
                                    </CSSWidgetEditorListItem>
                                ) : (
                                    <></>
                                );
                            }}
                            onDrag={(dragIndex, hoverIndex) => {
                                if (content.files !== undefined) {
                                    onChange({ files: arraySwapElements(content.files, dragIndex, hoverIndex) });
                                }
                            }}
                        />
                    </CSSEditorComponentWrapper>
                )}
            </CSSEditorWidgetProperties>
            <JRCButton onClick={() => onSave(content)} variant={'outlined'} minWidth={'100%'}>
                {intl.formatMessage({ id: 'PANEL_Save_And_Close' })}
            </JRCButton>
        </CSSEditor>
    );
};
